import { parse } from 'date-fns';

export const capitalize = (text: string): string => {
  return text.charAt(0).toUpperCase() + text.substring(1);
};

export const parseDate = (text: string, format = 'dd-MM-yyyy') => {
  return parse(text, format, Date.now());
};
